import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProductCodeContainer from '../../common/components/code-container/components/product-code-container';
import { setHomePage } from '../../common/components/emerald-home-page/emerald-home-page';
import OwnBagSelectionWindow from './own-bag-selection-window';
import Keypad from 'src/keypad/components/keypad';

type Props = IOwnBagProps;

export const showOwnBagContainer = (props: Props): void => {
  setHomePage(<OwnBagContainer {...props} />);
};

export const OwnBagContainer: React.FC<Props> = (props: Props): JSX.Element => {
  const { t } = useTranslation();

  const handleSubmit = () => {
    props.onKeypadSubmit(parseInt(inputValue));
  };

  const [inputValue, setInputValue] = useState('');

  const handleInputChange = e => {
    const r = parseInt(e.target.value.replace(/[^\d]+/gi, ''), 10);
    setInputValue(isNaN(r) ? '' : r.toString());
  };

  const keypadSubmitButton = {
    label: 'OK',
    onClick: handleSubmit,
    testId: 'own-bag-keypad-button',
    disabled: inputValue === '',
  };

  return (
    <ProductCodeContainer
      headerTitle={t('OwnBagTitle')}
      onKeypadSubmit={keypadSubmitButton.onClick}
      keypadComponent={
        <Keypad
          keyboardId='own-bag-keypad'
          disableManualWeight
          noInputField={true}
          disableQuantity
          topLabelText={t('OwnBagKeypadLabelText')}
          submitButton={keypadSubmitButton}
          visible
          keypadTestIdPrefix='own-bag-keypad-'
          disableDecimalInput={true}
        />
      }
    >
      <OwnBagSelectionWindow
        onCancel={props.onCancel}
        onChange={handleInputChange}
        onSubmit={handleSubmit}
        inputValue={inputValue}
      />
    </ProductCodeContainer>
  );
};

export interface IOwnBagProps {
  onCancel: () => void;
  onKeypadSubmit: (quantity: number) => void;
}
